var _defs, _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuspension(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.22 131.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#11ccea;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 65.61,
    cy: 65.61,
    r: 65.61
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.85,226.78a8.33,8.33,0,0,1,1-1.24l36.55-30.46c2.93-2.44,6.08-2.43,9,0l11.41,9.54.75.6c0-.38.05-.64.05-.9v-8.71c0-1.66.55-2.19,2.23-2.2h9c1.6,0,2.17.59,2.17,2.19q0,10,0,20a1.6,1.6,0,0,0,.65,1.38c3.43,2.81,6.84,5.66,10.25,8.49,1.39,1.16,1.47,1.95.33,3.32-.85,1-1.69,2-2.54,3a1.82,1.82,0,0,1-3,.25L301,203.11l-1.07-.89L296,205.47,264.22,232c-1.21,1-2.09.93-3.09-.27s-2.19-2.64-3.28-4Z",
    transform: "translate(-234.33 -163.79)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.27,260.29H273.84c-2.67,0-4-1.31-4-4q0-11.91,0-23.83a1.45,1.45,0,0,1,.51-1.29q14.53-11.94,29.05-23.93l.52-.41c.22.17.46.34.68.53q14.43,11.89,28.84,23.8a1.7,1.7,0,0,1,.55,1.15q0,12.16,0,24.33a3.35,3.35,0,0,1-3.42,3.63c-6.52,0-13,0-19.56,0a2.23,2.23,0,0,1-.39-.08V240.29H293.27Z",
    transform: "translate(-234.33 -163.79)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspension);
export default __webpack_public_path__ + "static/media/suspension.f673769424ece88755cfb0fffe99c487.svg";
export { ForwardRef as ReactComponent };